// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"9f501a6f","210":"ab16fe2e","241":"1d6207df","271":"8dbfb0eb","344":"8a12dd0a","413":"4a931229","423":"55bb4e75","453":"e34a9e30","483":"523263c4","738":"cd557d3a","849":"ffac78df","914":"d9c6d9cd"}[chunkId] + ".chunk.js";
};